import { createContext, useContext, useState, type ReactNode } from 'react';

interface SitePanelCtx {
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
}

const SitePanelContext = createContext<SitePanelCtx | null>(null);

export function SitePanelProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <SitePanelContext.Provider
      value={{
        isOpen,
        toggle: () => setIsOpen((v) => !v),
        open:   () => setIsOpen(true),
        close:  () => setIsOpen(false),
      }}
    >
      {children}
    </SitePanelContext.Provider>
  );
}

export function useSitePanel() {
  const ctx = useContext(SitePanelContext);
  if (!ctx) throw new Error('useSitePanel must be used inside SitePanelProvider');
  return ctx;
}
